import { connect } from 'react-redux';
import NavigationMenu from './navigation-menu.component';

const mapStateToProps = ({ player }) => ({
  queue: player.queue,
  activeIndex: player.activeIndex,
  activeTheme: player.ebookData.activeTheme,
});

export default connect(mapStateToProps)(NavigationMenu);
